// extracted by mini-css-extract-plugin
export var closeButton = "_g8-1";
export var closeX = "_g8-3";
export var container = "_g8-0";
export var image = "_g8-2";